// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2mhtU","file":"styles_file__3Tntf"};